import React from 'react';
import { motion } from 'framer-motion';
import { animationParams, animationVariants } from 'fragments';
import { abaCardsInfo } from './constants';
import { YourABACard } from './yourABACard';
import { useWidth } from 'utils';

export const YourABAPractice = () => {
    const width = useWidth();

    return (
        <div className="your-ABA-practice-wrapper">
            <div className="container">
                <div className="your-ABA-practice-block">
                    <div style={{ overflow: 'hidden' }}>
                        <motion.h2 className="your-ABA-practice-title" {...animationParams} variants={animationVariants.titleVariant}>
                            Everything your ABA practice needs in one place
                        </motion.h2>
                    </div>

                    <div style={{ overflow: 'hidden' }}>
                        <motion.p className="your-ABA-practice-text" {...animationParams} variants={animationVariants.titleVariant}>
                            Practice Management, Data Collection, and Revenue Cycle Management working together in one connected platform
                        </motion.p>
                    </div>

                    <div className="your-ABA-practice-cards-wrapper">
                        {abaCardsInfo(width).map((item, index) => (
                            <motion.div
                                key={index}
                                className="your-ABA-practice-cards-block"
                                {...animationParams}
                                variants={animationVariants.cardsVariant}
                            >
                                <YourABACard {...item} />
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
